import { ActionsAndSubjectsResponse } from "@/types/WorkflowCreate/AppConfiguration";
import { SelectOption } from "@/types/inputField";

export const getAllActionsByApp = (
  actionsAndSubjects: ActionsAndSubjectsResponse[] | undefined
): SelectOption[] => {
  if (!actionsAndSubjects) return []

  return actionsAndSubjects
    .filter(actionWithSubject => actionWithSubject.availableSubjects?.length)
    .map(actionWithSubject => ({
      id: actionWithSubject.actionCode,
      value: actionWithSubject.actionDisplayName,
      description: actionWithSubject.actionDescription
    }))
}
